// Generated from /Users/pyt/Downloads/AudienceLogic.g4 by ANTLR 4.7.1
// jshint ignore: start
import antlr4 from 'antlr4';

const serializedATN = [
  '\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964',
  "\u0002\t'\b\u0001\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004\u0004",
  '\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t\u0007',
  '\u0004\b\t\b\u0003\u0002\u0003\u0002\u0003\u0003\u0003\u0003\u0003\u0004',
  '\u0003\u0004\u0003\u0005\u0003\u0005\u0003\u0006\u0003\u0006\u0003\u0007',
  '\u0006\u0007\u001d\n\u0007\r\u0007\u000e\u0007\u001e\u0003\b\u0006\b',
  '"\n\b\r\b\u000e\b#\u0003\b\u0003\b\u0002\u0002\t\u0003\u0003\u0005',
  '\u0004\u0007\u0005\t\u0006\u000b\u0007\r\b\u000f\t\u0003\u0002\u0004',
  '\u0003\u00022;\u0005\u0002\u000b\f\u000e\u000f""\u0002(\u0002\u0003',
  '\u0003\u0002\u0002\u0002\u0002\u0005\u0003\u0002\u0002\u0002\u0002\u0007',
  '\u0003\u0002\u0002\u0002\u0002\t\u0003\u0002\u0002\u0002\u0002\u000b',
  '\u0003\u0002\u0002\u0002\u0002\r\u0003\u0002\u0002\u0002\u0002\u000f',
  '\u0003\u0002\u0002\u0002\u0003\u0011\u0003\u0002\u0002\u0002\u0005\u0013',
  '\u0003\u0002\u0002\u0002\u0007\u0015\u0003\u0002\u0002\u0002\t\u0017',
  '\u0003\u0002\u0002\u0002\u000b\u0019\u0003\u0002\u0002\u0002\r\u001c',
  '\u0003\u0002\u0002\u0002\u000f!\u0003\u0002\u0002\u0002\u0011\u0012',
  '\u0007(\u0002\u0002\u0012\u0004\u0003\u0002\u0002\u0002\u0013\u0014',
  '\u0007~\u0002\u0002\u0014\u0006\u0003\u0002\u0002\u0002\u0015\u0016',
  '\u0007#\u0002\u0002\u0016\b\u0003\u0002\u0002\u0002\u0017\u0018\u0007',
  '*\u0002\u0002\u0018\n\u0003\u0002\u0002\u0002\u0019\u001a\u0007+\u0002',
  '\u0002\u001a\f\u0003\u0002\u0002\u0002\u001b\u001d\t\u0002\u0002\u0002',
  '\u001c\u001b\u0003\u0002\u0002\u0002\u001d\u001e\u0003\u0002\u0002\u0002',
  '\u001e\u001c\u0003\u0002\u0002\u0002\u001e\u001f\u0003\u0002\u0002\u0002',
  '\u001f\u000e\u0003\u0002\u0002\u0002 "\t\u0003\u0002\u0002! \u0003',
  '\u0002\u0002\u0002"#\u0003\u0002\u0002\u0002#!\u0003\u0002\u0002\u0002',
  '#$\u0003\u0002\u0002\u0002$%\u0003\u0002\u0002\u0002%&\b\b\u0002\u0002',
  '&\u0010\u0003\u0002\u0002\u0002\u0005\u0002\u001e#\u0003\b\u0002\u0002',
].join('');

const atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map((ds, index) => new antlr4.dfa.DFA(ds, index));

class AudienceLogicLexer extends antlr4.Lexer {
  constructor(input) {
    super(input);
    this._interp = new antlr4.atn.LexerATNSimulator(this, atn, decisionsToDFA, new antlr4.atn.PredictionContextCache());
    return this;
  }

  get atn() {
    return atn;
  }
}

AudienceLogicLexer.EOF = antlr4.Token.EOF;
AudienceLogicLexer.AND = 1;
AudienceLogicLexer.OR = 2;
AudienceLogicLexer.NOT = 3;
AudienceLogicLexer.LPAREN = 4;
AudienceLogicLexer.RPAREN = 5;
AudienceLogicLexer.IDENTIFIER = 6;
AudienceLogicLexer.WS = 7;

AudienceLogicLexer.prototype.channelNames = ['DEFAULT_TOKEN_CHANNEL', 'HIDDEN'];

AudienceLogicLexer.prototype.modeNames = ['DEFAULT_MODE'];

AudienceLogicLexer.prototype.literalNames = [null, "'&'", "'|'", "'!'", "'('", "')'"];

AudienceLogicLexer.prototype.symbolicNames = [null, 'AND', 'OR', 'NOT', 'LPAREN', 'RPAREN', 'IDENTIFIER', 'WS'];

AudienceLogicLexer.prototype.ruleNames = ['AND', 'OR', 'NOT', 'LPAREN', 'RPAREN', 'IDENTIFIER', 'WS'];

AudienceLogicLexer.prototype.grammarFileName = 'AudienceLogic.g4';

export { AudienceLogicLexer };
